import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

Vue.http.options.root = process.env.VUE_APP_SERVER

Vue.http.options.emulateJSON = true;

Vue.http.interceptors.push((request, next) => {
    let token = localStorage.getItem('token')
    request.headers.set('Access-Control-Allow-Origin', '*')
    if (token) request.headers.set('Authorization', token)
    request.headers.set('Accept', 'application/json')
    next()
})
